import { HISTORY_TYPE, IHistoryStep, ILanding, ILandingSection, SECTION_DESIGN_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { useLandingStore } from "src/modules/pe-landing-module/data/store"
import updateHistory from "./updateHistory"

 
const changeSectionDesignType = ( section: ILandingSection, type: SECTION_DESIGN_TYPE ) => {
    const currentLanding: ILanding = useLandingStore.getState().currentLanding
    const prevData          = JSON.parse( JSON.stringify( section ) )
    const newSection: any   = { 
        ...section, 
        designType: type,
        isVertical: !![ SECTION_DESIGN_TYPE.VERTICAL_CAROUSEL, SECTION_DESIGN_TYPE.VERTICAL_TABS, SECTION_DESIGN_TYPE.VTIMELINE ].includes(type)
    } 
    const historyStep: IHistoryStep = {
        data:  newSection,
        prevData,
        type: HISTORY_TYPE.SECTION,
        title : "Update section's design type",
    }
    const newLanding = {
        ...currentLanding,
        sections: currentLanding.sections.map((sec: ILandingSection) => {
            if(sec.id === section?.id ) {
                return newSection
            }
            return sec
        })
    }  
    updateHistory( historyStep, newLanding ) 
}
export default changeSectionDesignType